import React, { useRef, useState } from "react";
import { Badge, Popover, SheetContainer, Text } from "@bookingcom/bui-react";
import { TriggerAttributes } from "@bookingcom/bui-react/components/_base/Flyout/Flyout.types";
import { I18nChildContext, t, useI18n } from "@bookingcom/lingojs-react";
import useUserAgent from "../../../../hooks/useUserAgent";

type Props = {
  isTicketTypePage: boolean;
};

const FlexTicketRecommendedBadge = ({ isTicketTypePage }: Props) => {
  const { isMobile } = useUserAgent();
  const i18n = useI18n() as I18nChildContext;

  const [showDescription, setShowDescription] = useState(false);

  const contentRef = useRef<HTMLDivElement>(null);

  const renderBadge = (attributes?: TriggerAttributes) => (
    <span
      aria-label={`. ${i18n.trans(t("flights_apex_ticket_type_flex_rex_badge"))},  ${i18n.trans(
        t("flights_apex_ancillaries_flex_rex_hover")
      )}`}
    >
      <Badge
        attributes={{
          "aria-live": "polite",
          role: "button",
          tabIndex: 0,
          onClick: isMobile ? () => setShowDescription(true) : undefined,
          ...attributes
        }}
        variant="constructive"
        text={i18n.trans(t("flights_apex_ticket_type_flex_rex_badge"))}
      />
    </span>
  );

  const description = (
    <Text>
      {i18n.trans(
        isTicketTypePage ? t("flights_apex_ancillaries_flex_rex_hover") : t("flights_apex_ancillary_rex_hover")
      )}
    </Text>
  );

  if (isMobile) {
    return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      <span
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
        }}
      >
        {renderBadge()}
        <SheetContainer
          title={i18n.trans(t("flights_apex_ticket_type_flex_rex_popup_title"))}
          active={showDescription}
          onCloseTrigger={() => setShowDescription(false)}
          closeAriaLabel={i18n.trans(t("a11y_flights_apex_ticket_type_flex_rex_popup_close"))}
        >
          {description}
        </SheetContainer>
      </span>
    );
  }

  return (
    <Popover size="medium" position="end" triggerType="hover">
      <Popover.Trigger>{renderBadge}</Popover.Trigger>
      <Popover.Content attributes={{ ref: contentRef }}>{description}</Popover.Content>
    </Popover>
  );
};

export default FlexTicketRecommendedBadge;
